function Copenhell26Logo() {
  return (
    <img
      height="140"
      width="366"
      src="/logos/CH26-LOGO-RGB-opt.png"
      className="w-full max-md:scale-150 h-[140px] object-contain px-2"
      alt="Copenhell Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { Copenhell26Logo };
